import ProfileWorkAvailabilitySection from './ProfileWorkAvailabilitySection.component';

export default ProfileWorkAvailabilitySection;